import { combineReducers, applyMiddleware } from "redux";
// import rootReducer from '../config/reducer'
import { storeReducer } from "../config/reducer";
import storage from 'redux-persist/lib/storage'
import { FLUSH, PAUSE, PERSIST, persistReducer, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import { configureStore } from "@reduxjs/toolkit";
import { migrate } from "../migrations/migrations";


const reducers = combineReducers({
    items: storeReducer,
});

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    migrate,           // 🔥 ADD THIS
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})

export default store;

export type RootState = ReturnType<typeof store.getState>